import styled from "styled-components";
import { Link } from "react-router-dom";

// import FacebookIcon from '@mui/icons-material/Facebook';
// import TwitterIcon from '@mui/icons-material/Twitter';
// import LinkedInIcon from '@mui/icons-material/LinkedIn';
// import InstagramIcon from '@mui/icons-material/Instagram';

import logoimg from '../assets/img/logo.png';
import titleimg from '../assets/img/true_extract.png';

const Container = styled.div`
  // background-color: var(--dark-gray);
  // color: white;
  // padding: 60px 60px 20px;
  // width: 100%;
`;



const Footer = () => {
  return (
    <Container>
      <footer>
        <div className="container">
          <div className="footer-content">
            <div className="footer-logo">
              <img src={logoimg} alt="True-Extract" />
              <img src={titleimg} alt="True-Extract" className="footer-brand" />
            </div>
            <div className="footer-text">
              © 2026 True-Extract. All rights reserved. | Professional Mobile Forensics
            </div>
            <div className="footer-links">
              <Link to="/privacy-policy">Privacy Policy</Link>
              <Link to="/terms-of-service">Terms of Service</Link>
            </div>
          </div>
        </div>
      </footer>

    </Container>
  );
};

export default Footer;
